import { FC } from "react";
import Lottie from "lottie-react";

interface LottieIconProps {
  size?: number;
  LottieAnimation: any;
}

const CustomLottieIcon: FC<LottieIconProps> = ({
  size = 24,
  LottieAnimation,
}) => {
  return (
    <Lottie
      animationData={LottieAnimation}
      loop={true}
      autoplay
      style={{ width: size, height: size }}
    />
  );
};

export default CustomLottieIcon;
